import React, { FunctionComponent } from "react";

import style from "./confirmation.module.scss";
import { Button } from "../button";
import myHistory from "../../history";
import { translate } from "../../translations/translate";

export const Confirmation = ({
  orderNumber,
  startDate,
  loading = false,
  withMapButton = false,
}) => {
  return (<div className={style["card"]}>
    {
      loading ? (<div className={style.loader} />) : (
        <>
          <h1 className={style["header-title"]} > {translate("confirmed")} </h1>
          <h2 className={style["sub-title"]}> {translate("your-order-number")} </h2>
          <h1 className={style["order-number"]}> {orderNumber} </h1>
          { withMapButton ? (
            <Button
              label={translate("back-to-map")}
              onClick={() => myHistory.push("/map")}
            />
          ) : null}
        </>
      )
    }
</div>);
};
